import each from 'lodash/each';
import { assert } from '../utils/assert';

export default function install(Vue) {
  // Register modal component, this is used as actual content per "implementation"
  Vue.component('modal', () => import('./modal.vue'));

  // calling $modal(<vue component here>) will automatically attach and open to the body
  const modalStack = [];

  Object.defineProperty(Vue.prototype, '$modal', {
    get: () => (component = false, params, events) => {
      // If we pass no parameters, we just remove all modals
      if (component === false) {
        each(modalStack, (vm) => {
          vm.$destroy();
        });

        return;
      }

      const vm = new Vue({
        name: 'Modals',
        render: r => (r(component, { props: params })),
        destroyed() {
          // Clean up reference in stack
          modalStack.splice(modalStack.indexOf(vm), 1);
        },
      });

      // Support listening for events
      if (events) {
        vm.$nextTick(() => {
          assert(vm.$children.length > 0, 'No child found even though events want to be registered');

          const child = vm.$children[0];
          each(events, (handler, name) => child.$on(name, handler));
        });
      }

      document.querySelector('body').appendChild(vm.$mount().$el);
      modalStack.push(vm);
    },
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/modal/index.js